import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the shape of the state
interface CustomizerState {
  topbarBg: string;
  customizerSidebar: boolean;
  isRTL: boolean;
  isDark: boolean;
  isMiniSidebar: boolean;
  sidebarBg: string;
  isTopbarFixed: boolean;
  isMobileSidebar: boolean;
  isSidebarFixed: boolean;
  isLayoutHorizontal: boolean;
  isInnerRightPart: boolean;
}

// Define the initial state
const initialState: CustomizerState = {
  topbarBg: 'primary',
  customizerSidebar: false,
  isRTL: false,
  isDark: false,
  isMiniSidebar: false,
  sidebarBg: 'white',
  isTopbarFixed: true,
  isMobileSidebar: false,
  isSidebarFixed: true,
  isLayoutHorizontal: true,
  isInnerRightPart: false, // For three-column layout right part visibility
};

// Create the slice with type-safe reducers
export const CustomizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    ChangeTopbarColor: (state, action: PayloadAction<string>) => {
      state.topbarBg = action.payload;
    },
    ToggleCustomizer: (state) => {
      state.customizerSidebar = !state.customizerSidebar;
    },
    ChangeDirection: (state, action: PayloadAction<boolean>) => {
      state.isRTL = action.payload;
    },
    ChangeDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDark = action.payload;
    },
    ToggleMiniSidebar: (state) => {
      state.isMiniSidebar = !state.isMiniSidebar;
    },
    ChangeSidebarColor: (state, action: PayloadAction<string>) => {
      state.sidebarBg = action.payload;
    },
    ToggleTopbar: (state, action: PayloadAction<boolean>) => {
      state.isTopbarFixed = action.payload;
    },
    ToggleMobileSidebar: (state) => {
      state.isMobileSidebar = !state.isMobileSidebar;
    },
    FixedSidebar: (state) => {
      state.isSidebarFixed = !state.isSidebarFixed;
    },
    ToggleHorizontal: (state) => {
      state.isLayoutHorizontal = !state.isLayoutHorizontal;
    },
    ToggleInnerRightPart: (state) => {
      state.isInnerRightPart = !state.isInnerRightPart;
    },
  },
});

// Export actions
export const {
  ChangeTopbarColor,
  ToggleCustomizer,
  ChangeDirection,
  ChangeDarkMode,
  ToggleMiniSidebar,
  ChangeSidebarColor,
  ToggleTopbar,
  ToggleMobileSidebar,
  FixedSidebar,
  ToggleHorizontal,
  ToggleInnerRightPart,
} = CustomizerSlice.actions;

// Export reducer
export default CustomizerSlice.reducer;
